import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { mergeMap} from 'rxjs/operators';
import { UserService } from './user.service';
import { Location } from "@angular/common";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {

    constructor(private userService: UserService, private location: Location) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.userService.isAuthenticated()) {
            if (req.url === environment.appBackUrl + "/api/token/refresh") {
                req = req.clone({
                    setHeaders: {
                        'Content-Type' : "application/json; charset=utf-8",
                        'Accept'       : "application/json"
                    }
                });
                return next.handle(req);
            } else { 
                return this.getUserToken().pipe(mergeMap((token) => {
                    if (token) {
                        if (this.userService.currentUser.refreshToken && req.url.match("\/api\/")) {
                            return this.getUserApiToken().pipe(mergeMap((refreshToken) => {
                                this.userService.currentUser.apiToken = refreshToken;
                                req = req.clone({
                                    setHeaders: {
                                        'Content-Type' : "application/json; charset=utf-8",
                                        'Accept'       : "application/json",
                                        Authorization: `Bearer ${this.userService.currentUser.apiToken}`
                                    }
                                });
                                return next.handle(req);
                            }));
                        } else {
                            req = req.clone({
                                setHeaders: {
                                    'Content-Type' : "application/json; charset=utf-8",
                                    'Accept'       : "application/json",
                                    Authorization: `Bearer ${this.userService.currentUser.apiToken}`
                                }
                            });
                        }
                    }
                    return next.handle(req);
                }));
            }
        } else {
            if (req.url === environment.appBackUrl + "/api/token/refresh") {
                req = req.clone({
                    setHeaders: {
                        'Content-Type' : "application/json; charset=utf-8",
                        'Accept'       : "application/json"
                    }
                });
                return next.handle(req);
            } else {
                const exceptionsPatterns = [
                    "open\/client\/(.*)",
                    "\/open\/client\/message\/(.*)",
                    "revokeConsent\/(.*)"
                ];
                if (this.location.path().match("(?:" + exceptionsPatterns.join('|') + ")")) {
                    if (this.userService.currentUser.refreshToken && req.url.match("\/api\/")) { // refresh token du patient à chaque action
                        return this.getUserApiToken().pipe(mergeMap((refreshToken) => {
                            this.userService.currentUser.apiToken = refreshToken;
                            req = req.clone({
                                setHeaders: {
                                    'Content-Type' : "application/json; charset=utf-8",
                                    'Accept'       : "application/json",
                                    Authorization: `Bearer ${this.userService.currentUser.apiToken}`
                                }
                            });
                            return next.handle(req);
                        }));
                    } else {
                        req = req.clone({
                            setHeaders: {
                                'Content-Type' : "application/json; charset=utf-8",
                                'Accept'       : "application/json",
                                Authorization: `Bearer ${this.userService.currentUser.apiToken}`
                            }
                        }); 
                    }
                }
            }
        }
        return next.handle(req);
    }

    getUserToken(): Observable<string> {
        const tokenPromise: Promise<string> = this.userService.refreshToken();
        const tokenObservable: Observable<string> = from(tokenPromise);
        return tokenObservable;
    }

    getUserApiToken(): Observable<string> {
        const tokenPromise: Promise<string> = this.userService.refreshApiToken();
        const tokenObservable: Observable<string> = from(tokenPromise);
        return tokenObservable;
    }
}
